import { render, staticRenderFns } from "./badge-nudity-classification.vue?vue&type=template&id=794a117e&"
import script from "./badge-nudity-classification.vue?vue&type=script&lang=js&"
export * from "./badge-nudity-classification.vue?vue&type=script&lang=js&"
import style0 from "./badge-nudity-classification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('794a117e')) {
      api.createRecord('794a117e', component.options)
    } else {
      api.reload('794a117e', component.options)
    }
    module.hot.accept("./badge-nudity-classification.vue?vue&type=template&id=794a117e&", function () {
      api.rerender('794a117e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/badges/badge-nudity-classification.vue"
export default component.exports